
  import { css } from 'lit';
  export const styles = css`:host{border:.0625rem solid var(--outline-color);background:var(--background);border-radius:var(--border-radius)}:host([elevated]){box-shadow:var(--resting-elevation)}:host([elevated]:hover),:host([elevated]:focus-within){box-shadow:var(--hover-elevation)}`;
  